import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import { USER_CL_EVENTS_KEY } from '@/config';
import types from './mutation-types';

function subscribe(store) {
  store.subscribe((mutation, { ClEvents, Auth }) => {
    switch (mutation.type) {
      case types.SET_CL_EVENTS: {
        if (!isEmpty(Auth.user)) {
          const cookieKey = `${USER_CL_EVENTS_KEY}/${Auth.user.id}`;
          Cookies.set(cookieKey, ClEvents.clEvents, { expires: 999 });
        }

        break;
      }

      case types.UPDATE_CL_EVENT: {
        if (!isEmpty(Auth.user)) {
          const cookieKey = `${USER_CL_EVENTS_KEY}/${Auth.user.id}`;
          Cookies.set(cookieKey, ClEvents.clEvents, { expires: 999 });
        }

        break;
      }

      default: {
        break;
      }
    }
  });
}

export default (store) => {
  subscribe(store);
};



// WEBPACK FOOTER //
// ./src/app/cl-events/store/plugin.js